import {
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  CLEAR_MESSAGE,
  SAMPLE_FILE_REQUEST,
  SAMPLE_FILE_FAILURE,
  SAMPLE_FILE_SUCCESS
} from './constants';
import I18n from '../../config/locales/e_i18n';

let initialState = {
  loading: false,
  message: '',
  messageType: '',
  sampleFile: [],
  successList: [],
  errorList: [],
  sampleFileMerchandiseFailed: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_FILE_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        successList: action.payload.successList,
        errorList: [],
        messageType: 'success',
        message: I18n.t('message.successMessageUpload')
      };
    case UPLOAD_FILE_FAILURE:
      const message = I18n.t('message.rowsFailed', {
        failedCount: action.payload.errorList.length,
        totalCount: action.payload.errorList.length + action.payload.successList.length
      });
      return {
        ...state,
        loading: false,
        successList: action.payload.successList,
        errorList: action.payload.errorList,
        messageType: 'error',
        message
      };
    case CLEAR_MESSAGE:
      return { ...state, messageType: '', message: '' };
    case SAMPLE_FILE_REQUEST:
      return { ...state, loading: true };
    case SAMPLE_FILE_SUCCESS:
      return {
        ...state,
        sampleFile: action.sampleFile,
        loading: false
      };
    case SAMPLE_FILE_FAILURE:
      return {
        ...state,
        message: action.error,
        messageType: 'error',
        loading: false,
        sampleFileMerchandiseFailed: true
      };
    default:
      return state;
  }
};

export default reducer;
